import { PublicClientApplication } from '@azure/msal-browser'

export const GRAPH_REGISTER_SCOPE = 'https://graph.microsoft.com/UserAuthMethod-External.ReadWrite'
export const REDIRECT_PATH = '/entra-redirect.html'

const GRAPH_BASE = 'https://graph.microsoft.com/v1.0'

// A fresh client per call; the token stays in memory and is never stored or sent to the backend.
export async function signInToRegister(tenantId: string, clientId: string): Promise<string> {
  const app = new PublicClientApplication({
    auth: {
      clientId,
      authority: 'https://login.microsoftonline.com/' + tenantId,
      redirectUri: window.location.origin + REDIRECT_PATH,
      // No offline_access: no refresh token is wanted.
      OIDCOptions: { defaultScopes: ['openid', 'profile'] },
    },
    cache: { cacheLocation: 'memoryStorage' },
  })
  await app.initialize()
  const result = await app.acquireTokenPopup({ scopes: [GRAPH_REGISTER_SCOPE], prompt: 'select_account' })
  return result.accessToken
}

export function signInProblem(e: unknown): 'cancelled' | 'popup_blocked' | 'other' {
  const code = (e as { errorCode?: unknown } | null)?.errorCode
  const message = e instanceof Error ? e.message : ''
  if (code === 'popup_window_error' || code === 'empty_window_error') return 'popup_blocked'
  if (
    code === 'user_cancelled' ||
    code === 'consent_required' ||
    code === 'access_denied' ||
    message.includes('AADSTS65004') ||
    message.includes('AADSTS90094')
  ) {
    return 'cancelled'
  }
  return 'other'
}

export interface GraphReply {
  status: number
  headers: { get(name: string): string | null }
  json(): Promise<unknown>
}
export type GraphCall = (method: 'GET' | 'POST', path: string, body?: unknown) => Promise<GraphReply>

export function graphCaller(token: string): GraphCall {
  return (method, path, body) =>
    fetch(GRAPH_BASE + path, {
      method,
      headers: {
        Authorization: `Bearer ${token}`,
        ...(body === undefined ? {} : { 'Content-Type': 'application/json' }),
      },
      body: body === undefined ? undefined : JSON.stringify(body),
    })
}
